export const LINK_TO_CODEX_SHOP = 'https://codex-stg.clarityclient.com/';
